export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API_ROUTES = {
  AUTH: {
    REGISTER: `auth/register`,
    LOGIN: `auth/login`,
    LOGIN_RECRUITER: `auth/login-recruiter`,
    REFRESH_TOKEN: `auth/refresh`,
    LOGOUT: 'auth/logout',
    COMPLETE_PROFILE: `auth/complete-profile`,
    FORGOT_PASSWORD: `auth/forgot-password`,
    RESET_PASSWORD: `auth/reset-password`,
    CHANGE_PASSWORD: `auth/change-password`,
    RESEND_EMAIL: `auth/resend-verification`,
    SEND_VERIFICATION: `auth/send`,
    VERIFY_CODE: `auth/verify`,
    VERIFY_RECRUITER_CODE: `auth/verify-recruiter-code`,
    FACEBOOK_AUTH_URL: `auth/facebook/url`,
    FACEBOOK_CALLBACK: `auth/facebook/callback`,
  },
  AI: {
    ASK_QUESTION: `ai/ask-question`,
    FIND_COMPANY: `ai/find-company`,
  },
  ONBOARDING: {
    PARSE_RESUME: `onboarding/parse-resume`,
    DRAFT: `onboarding/draft`,
    SAVE_DRAFT: `onboarding/save-draft`,
    FINALIZE: `onboarding/finalize`,
  },
  RECRUITER: {
    SHARE_PROFILE: `${BASE_URL}recruiter/share-profile`,
    VERIFY_RECRUITER_AND_LOGIN: `${BASE_URL}recruiter/verify-and-login`,
    CONFIRM_ACCESS: `${BASE_URL}recruiter/confirm-access`,
    REQUEST_ACCESS: `${BASE_URL}recruiter/request-access`,
    RESPOND_ACCESS_REQUEST: `${BASE_URL}recruiter/access-requests/respond`,
  },
  USER: {
    GET_CURRENT_USER: `user/current-user`,
    GET_USER_PUBLIC: `user`,
    UPDATE_USER: `user/update-user`,
    COMPLETE_PROFILE: `profile/complete`,
    VERIFY_RECRUITER: `/user/verify-recruiter`,
    REQUEST_PROFILE_ACCESS: `user/request-access`,
    DELETE_USER: `user/me`,
    DEACTIVATE_USER: `user/me/deactivate`,
    ADMIN_DELETE: `user`,
    POST_USER_FEEDBACK: `post-feedback`,
    MARK_FIRST_PROMPT: `mark-first-prompt-congrats`,
    ONBOARD_COMPLETE: `user/onboarding-complete`,
    CHECK_USERNAME: `user/check-username`,
    EXPORT_DATA: `user/export-data`,
  },
  PORTFOLIO: {
    CREATE_PORTFOLIO: `portfolio`,
    CREATE_PORTFOLIO_SIMPLE: `portfolio/simple-create`,
    EDIT_PORTFOLIO: 'portfolio/update-portfolio',
    UPLOAD_FILES: `portfolio/upload-files`,
    GET_PORTFOLIO: 'portfolio',
    GET_PORTFOLIO_PUBLIC: 'portfolio',
    DELETE_PORTFOLIO: `portfolio/delete`,
    ACTIVATE_PORTFOLIO: `portfolio/activate-portfolio`,
    PATCH_PROJECT: (projectId: number | string) => `portfolio/projects/${projectId}`,
  },
  PROMPTS: {
    CREATE_PROMPTS: 'prompts',
    GET_PROMPTS: 'prompts',
    GET_PROMPTS_PUBLIC: 'prompts',
    EDIT_PROMPT: `prompt`,
    DELETE_PROMPT: `prompt`,
    DELETE_ALL_PROMPTS: `prompts`,
  },
  REFERENCE: {
    CREATE_REFERENCE: 'reference/create',
    VERIFY_REFERENCE: 'reference/verify',
    UPDATE_REFERENCE: '/reference',
    DELETE_REFERENCE: '/reference',
    RESEND_CONFIRMATION_EMAIL: '/reference/resend-confirmation',
  },
  CALENDAR: {
    CREATE_EVENT: `calendar/create`,
    GET_USER_EVENTS: `calendar`,
    GET_MEETING_REQUESTS: `calendar/meetings`,
    CREATE_MEETING_REQUEST: `calendar`,
    UPDATE_MEETING_REQUEST: `calendar/meetings`,
    GET_AVAILABLE_SLOTS: `calendar/slots`,
    GET_PUBLIC_EVENTS: 'calendar/username',
    DELETE_EVENT: `calendar/event`, // /:id
    UPDATE_EVENT: `calendar/event`, // /:id
  },
  CANDIDATE: {
    GET_CANDIDATE: `/u`,
  },
  NOTIFICATION: {
    CREATE_NOTIFICATION: '/notifications',
    GET_NOTIFICATION: '/notifications',
    MARK_AS_READ_NOTIFICATION: '/notifications/:id/read',
    MARK_ALL_AS_READ: '/notifications/mark-all-read',
    DELETE_A_NOTIFICATION: '/notifications/:id',
    DELETE_NOTIFICATION: '/notifications',
  },
  DASHBOARD: {
    TRENDS: `dashboard/trends`,
    LEARNING: `dashboard/learning`,
    ACTIVITIES: `dashboard/activities`,
    CONTINUED_LEARNING: `api/continued-learning`,
  },
  ACTIVITY: {
    FEED: `activity/`,
  },
  TRENDS: {
    CURRENT: `current-trends/`,
    dismiss: (id: string) => `current-trends/${id}/dismiss/`,
    ctaClick: (id: string) => `current-trends/${id}/cta-click/`,
    sourceClick: (id: string) => `current-trends/${id}/source-click/`,
  },
  // depreciated
  MESSENGER: {
    START_CONVERSATION: '/messenger/conversation',
    SEND_MESSAGE: '/messenger/message',
    GET_MESSAGES: '/messenger/:conversationId/messages',
    GET_QUESTIONS: '/messenger/questions',
    GET_CONTACTS: '/messenger/contacts',
    MARK_AS_READ: '/messenger/read',
    ASK_QUESTION: '/messenger/ask-question',
    GET_CONVERSATIONS: '/messenger/conversations',
    UPDATE_CONTACT_STATUS: '/messenger/update-contact-status/:id',
  },
  MESSAGESHUB: {
    START_CONVERSATION: '/messenger/conversation',
    SEND_MESSAGE: (conversationId: string) =>
      `/messageshub/conversations/${conversationId}/messages`,
    GET_MESSAGES: '/messageshub/conversations/:conversationId/messages',
    GET_QUESTIONS: '/messageshub/profile-questions/candidate',
    GET_CONTACTS: '/messageshub/contacts/candidate',
    GET_REQUESTS_FOR_CANDIDATE: '/messageshub/requests/candidate',
    ACCEPT_REQUEST: (requestId: string) => `/messageshub/requests/${requestId}/accept`,
    DECLINE_REQUEST: (requestId: string) => `/messageshub/requests/${requestId}/decline`,
    ANSWER_QUESTION: (questionId: string) => `/messageshub/profile-questions/${questionId}/answer`,
    MARK_AS_READ: (questionId: string) => `/messageshub/profile-questions/${questionId}/mark-read`,
    ASK_QUESTION: '/messenger/ask-question',
    GET_CONVERSATIONS: '/messageshub/conversations',
    DELETE_CONVERSATION: (conversationId: string) => `/messageshub/conversations/${conversationId}`,
    UPDATE_CONTACT_STATUS: '/messenger/update-contact-status/:id',
  },
  LIVECALENDAR: {
    ME_GET: `livecalendar/me`,
    GET_BUSY_SLOTS: `livecalendar/me/slots`,

    // Meeting Requests
    GET_MEETING_REQUESTS: `livecalendar/requests/for-me`, // GET list
    APPROVE_REQUEST: (id: string) => `livecalendar/requests/${id}/approve`,
    DENY_REQUEST: (id: string) => `livecalendar/requests/${id}/deny`,
    RESCHEDULE_REQUEST: (id: string) => `livecalendar/requests/${id}/reschedule`,
    ATTENDANCE_UPDATE: (id: string) => `livecalendar/requests/${id}/attendance`,
    DISCONNECT_GOOGLE: `livecalendar/integrations/disconnect/google`,
    SYNC_GOOGLE_CALENDAR: `livecalendar/me/busy-slots/sync-google`,
    BUSY_SLOT_UPDATE: (id: string) => `livecalendar/me/busy-slots/${id}`,
  },
  ANALYTICS: {
    OVERVIEW: `analytics/overview`,
    /** Full candidate dashboard: totals, profileStrength, breakdowns (+ 30/90 day windows on the same response). */
    DASHBOARD: `analytics/dashboard`,
    CANDIDATE_SNAPSHOT: `analytics/candidate-snapshot`,
    SECTION_BREAKDOWN: `analytics/sections`,
    PROMPT_OVERVIEW: `analytics/prompts/overview`,
    PROFILE_STRENGTH: `analytics/profile-strength`,

    // Profile Views
    PROFILE_VIEW_TOTAL: `analytics/profile/views/total`,
    PROFILE_VIEW_UNIQUE: `analytics/profile/views/unique`,
    PROFILE_VIEW_BY_TYPE: `analytics/profile/views/viewer-type`,
    PROFILE_VIEW_TIMELINE: `analytics/profile/views/timeline`,
    PROFILE_VIEW_SOURCE: `analytics/profile/views/source`,
    PROFILE_VIEW_DEVICE: `analytics/profile/views/device`,
    PROFILE_VIEW_PLATFORM: `analytics/profile/views/platform`,
    PROFILE_VIEW_MATRIX: `analytics/profile/views/source-viewer-matrix`,

    // Track views and events
    TRACK_PROFILE_VIEW: `analytics/view/profile`,
    TRACK_PROMPT_VIEW: `analytics/view/prompt`,

    // Likes
    LIKE: `analytics/like`,
    UNLIKE: `analytics/like`,
  },
};
